import PropTypes from 'prop-types';
import React, {useState} from 'react';

import {BANK_TYPES} from '../../../constants/typesMessages';
import {
  getMessageQuestionAccount,
  getMessageQuestionAccountBankCaixa,
  getMessageQuestionBank,
  getMessageQuestionBankWarning
} from '../../../services/bank';
import {HideButtonWhenLogout} from '../../../shared/components/HideButtonWhenLogout';
import {useChatStore} from '../../../store/slices/chatStore';
import {useInteractionStore} from '../../../store/slices/interactionStore';
import {useLogoutStore} from '../../../store/slices/logoutStore';
import MessageText from '../MessageText';
import './MessageBankAccountCaixa.style.scss';

export const MessageBankAccountCaixa = (props) => {
  const messages = useChatStore((state) => state.messages);
  const responseFlow = useChatStore((state) => state.responseFlow);
  const responseType = useChatStore((state) => state.responseType);
  const setMessages = useChatStore((state) => state.setMessages);
  const responseFlowChange = useChatStore((state) => state.responseFlowChange);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const actionLogout = useLogoutStore((state) => state.actionLogout);
  const setGoLogout = useLogoutStore((state) => state.setGoLogout);
  const continueChat = useLogoutStore((state) => state.continueChat);
  const continueFlow = useLogoutStore((state) => state.continueFlow);
  const continueType = useLogoutStore((state) => state.continueType);
  const disabledButtonSendMessage = useInteractionStore(
    (state) => state.disabledButtonSendMessage
  );
  const [hiddenButtons, setHiddenButtons] = useState(true);

  const enterAccountAgain = () => {
    setHiddenButtons(false);

    let messages = [
      {
        text: 'Digitar conta novamente',
        type: 'response-sent'
      }
    ];

    messages = getMessageQuestionAccount(messages);
    messages = getMessageQuestionAccountBankCaixa(messages);

    setMessages(messages);
    responseFlowChange(BANK_TYPES.BANK_ACC);
    responseTypeChange(BANK_TYPES.BANK_FLOW);
  };

  const chooseAnotherBank = () => {
    setHiddenButtons(false);

    let messages = [
      {
        text: 'Escolher outro banco',
        type: 'response-sent'
      }
    ];

    messages = getMessageQuestionBank(messages);
    messages = getMessageQuestionBankWarning(messages);

    setMessages(messages);
    responseFlowChange(BANK_TYPES.BANK_NAME);
    responseTypeChange(BANK_TYPES.BANK_FLOW);
    disabledButtonSendMessage('disabled');
  };

  const cancelAccreditation = () => {
    setHiddenButtons(false);
    setGoLogout(!actionLogout);
    continueChat(messages[messages.length - 1]);
    continueType(responseType);
    continueFlow(responseFlow);

    let messagesCancelBankStep = [
      {
        text: 'Cancelar credenciamento',
        type: 'response-sent'
      },
      {
        text: 'Você tem certeza de que deseja sair agora? Lembre-se de que todas as informações inseridas até agora serão perdidas, mas você sempre pode retornar quando quiser!',
        type: 'message-cancel-question'
      }
    ];

    setMessages(messagesCancelBankStep);
    responseTypeChange('disabled');
    disabledButtonSendMessage('');
  };

  return (
    <>
      <MessageText
        id={props.question.id}
        text={props.question.text}
        html_id="message-bank-account-caixa"
        data-testid="message-bank-account-caixa"
        data-aut-test="message-bank-account-caixa"
      />
      {hiddenButtons && (
        <HideButtonWhenLogout>
          <div className="message-line" id="container-btn-bank-account-caixa">
            <div className="div-button" id="msg-bank-account-caixa">
              <button
                id="digitar-conta-novamente"
                data-testid="digitar-conta-novamente"
                className="button-option"
                type="button"
                onClick={() => enterAccountAgain()}
              >
                DIGITAR CONTA NOVAMENTE
              </button>
              <button
                id="escolher-outro-banco"
                data-testid="escolher-outro-banco"
                className="button-option"
                type="button"
                onClick={() => chooseAnotherBank()}
              >
                ESCOLHER OUTRO BANCO
              </button>
              <button
                id="cancelar-credenciamento"
                data-testid="cancelar-credenciamento"
                className="button-option"
                type="button"
                onClick={() => cancelAccreditation()}
              >
                CANCELAR CREDENCIAMENTO
              </button>
            </div>
          </div>
        </HideButtonWhenLogout>
      )}
    </>
  );
};

MessageBankAccountCaixa.propTypes = {
  question: PropTypes.object
};
